module.exports = __webpack_public_path__ + "41195dd45115f1e5f4f2b2e18894985b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/thrift_savings_plan_2022_chart.png
// module id = 1749
// module chunks = 0